import Vue from 'vue';
//import router from '../router/index'

class VueFetch {
	constructor({ url }) {
		this.url = new URL(url, location.href).href;
	}

	async fetch(url, options) {
		try {
			let ret = await fetch(url, options);

			if (ret.ok) {
				if (ret.status === 200) {
					let json = await ret.json();
					return json;
				} else {
					return true;
				}
			// } else if (ret.status === 401) {
			// 	localStorage.removeItem('usuarioLogado');
			// 	router.push('/login');
			// 	throw { status: ret.status };
			} else if (ret.status === 412) {
				let json = await ret.json();
				throw { status: ret.status, msg: json.message };
			} else {
				let msg = 'Erro interno no servidor.';
				let json = await ret.json();
				if ((json) && (json.message)) {
					msg = json.message;
				}
				throw { status: ret.status, msg: msg };
			}
		} catch (err) {
			if (err && err.status) {
				throw err;
			}
			throw { status: -1, msg: 'Não foi possível conectar ao servidor' };
		}
	}

	async getAll(routes) {
		let promises = routes.map(r => this.get(r));
		return await Promise.all(promises);
	}

	async get(route, queryParams) {
		let url = new URL(route, this.url);
		url.search = new URLSearchParams(queryParams);
		return await this.fetch(url);
	}

	async delete(route) {
		return await this.fetch(new URL(route, this.url).href, {
			method: 'DELETE'
		});
	}

	async post(route, payload) {
		return await this.fetch(new URL(route, this.url).href, {
			method: 'POST',
			headers: {
				Accept: 'application/json, text/plain, */*',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(payload)
		});
	}

	async put(route, payload) {
		return await this.fetch(new URL(route, this.url).href, {
			method: 'PUT',
			headers: {
				Accept: 'application/json, text/plain, */*',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(payload)
		});
	}
}

let vueFetch = new VueFetch({ url: 'api/' });

Vue.prototype.$fetch = vueFetch;

export { vueFetch, VueFetch };
